'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return {
        center: ['50%', '85%'],
        size: '90%',
        startAngle: -90,
        endAngle: 90,
        background: {
            backgroundColor: '#F1F1F1',
            innerRadius: '60%',
            outerRadius: '100%',
            shape: 'arc'
        }
    };
};
//# sourceMappingURL=gauge.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/pane/gauge.js
 ** module id = 199
 ** module chunks = 0 1
 **/